export default {
  nav: {
    firstStep: "der erste schritt",
    navigate: "wie navigieren",
    whyUs: "warum veki?",
    nice: "was für ein schönes",
    shop: "shop",
    shopAll: "alles",
    shopContainers: "container",
    shopLarvals: "die larven",
    shopOrganizers: "veranstalter",
    shopBoxes: "boxen",
    shopCategoryKits: "kits",
    shopCategoryLabels: "labels",
    shopCategoryVouchers: "gutscheine",
    organizeDrawer: "organize fach",
    genDimensions: "zustellen masse",
    genDesign: "design",
    materials: "arten von oberflächen",
    blog: "inspiration",
    myAccount: "mein konto",
    contact: "kontakt"
  },
  user: {
    register: {
      email_blank: "Die E- Mail des Benutzers darf nicht leer sein.",
      password_blank: "Das Passwort des Benutzers darf nicht leer sein.",
      success: "Registrierung erfolgreich.",
      user_exists: "Benutzer mit diesem Namen / E-Mail existiert bereits."
    },
    login: {
      username_blank: "Der Benutzername darf nicht leer sein.",
      password_blank: "Passwort kann nicht leer sein.",
      invalid_username: "Dieser Benutzername ist falsch.",
      incorrect_password: "Dieses Passwort für diesen Benutzer ist falsch.",
      unexpected_error: "Ein unerwartetes Problem ist aufgetreten.",
      success: "Erfolgreich eingeloggt."
    },
    unexpected_error: "Ein unerwartetes Problem ist aufgetreten.",
    forgotten_pass: "Passwort vergessen?"
  },
  contact: {
    contact_subject_blank: "Der Betreff der Nachricht darf nicht leer sein.",
    contact_name_blank: "Absendername darf nicht leer sein.",
    contact_surname_blank: "Der Nachname des Absenders darf nicht leer sein.",
    contact_email_blank: "Die E-Mail des Absenders darf nicht leer sein.",
    contact_message_blank: "Die Nachricht darf nicht leer sein.",
    form_success: "Nachricht erfolgreich gesendet",
    form_failed:
      "Beim Versuch, die Nachricht zu senden, ist ein Fehler aufgetreten.",
    expired_captcha: "Der Captcha-Code ist abgelaufen."
  },
  cart: {
    update: {
      success: "Erfolgreich aktualisiert.",
      errror: "Beim Update ist ein Fehler aufgetreten."
    },
    shipping: {
      not_enough_data:
        "Es wurden nicht genügend Daten angegeben, um die Versandkosten zu berechnen."
    },
    coupon: {
      apply: {
        cart_empty: "Einkaufswagen kann nicht leer sein",
        code_blank: "Der Gutscheincode kann nicht leer sein.",
        code_invalid: "Der bereitgestellte Gutscheincode ist ungültig.",
        code_used_up:
          "Der bereitgestellte Gutschein hat die Nutzungsgrenze überschritten.",
        code_expired: "Der bereitgestellte Gutschein ist abgelaufen.",
        success: "Der Gutschein wurde erfolgreich hinzugefügt.",
        code_exists: "Der bereitgestellte Gutschein wurde bereits hinzugefügt.",
        error: "Ein unerwartetes Problem ist aufgetreten."
      },
      remove: {
        code_blank: "Der bereitgestellte Gutscheincode existiert nicht.",
        success: "Der Gutschein wurde erfolgreich entfernt.",
        code_not_removed: "Der Gutschein wurde nicht entfernt.",
        error: "Ein unerwartetes Problem ist aufgetreten."
      }
    }
  },
  checkout: {
    click_here: "Klicken Sie hier",
    message: ", um sich anzumelden / zu registrieren."
  },
  country: {
    PL: 'Polen',
    KZ: 'Kasachstan',
    AL: 'Albanien',
    AD: 'Andorra',
    AT: 'Österreich',
    BE: 'Bielgia',
    BY: 'Weißrussland',
    BA: 'Bosnien und Herzegowina',
    BG: 'Bulgarien',
    BG_BG_21: 'Smoljan',
    HR: 'Kroatien',
    ME: 'Montenegro',
    CZ: 'Tschechische Republik',
    DK: 'Dänemark',
    EE: 'Estland',
    FI: 'Finnland',
    FR: 'Frankreich',
    GR: 'Griechenland',
    ES: 'Spanien',
    NL: 'Niederlande',
    IE: 'Irland',
    IS: 'Island',
    LI: 'Liechtenstein',
    LT: 'Litauen',
    LU: 'Luxemburg',
    MK: 'Mazedonien',
    MT: 'Malta',
    MC: 'Monaco',
    DE: 'Deutschland',
    NO: 'Norwegen',
    PT: 'Portugal',
    RU: 'Russland',
    RO: 'Rumänien',
    SM: 'San Marino',
    RS: 'Serbien',
    CH: 'Schweiz',
    SE: 'Schweden',
    SK: 'Slowakei',
    SI: 'Slowenien',
    TR: 'Türkei',
    VA: 'Vatikan',
    GB: 'Großbritannien',
    HU: 'Ungarn',
    IT: 'Italien',
    LV: 'Lettland',
    CA_NS: 'Neuschottland'
  }
};